import React, { type ReactElement } from "react"
import type { ColumnShape } from "react-base-table"

type Props = {
  rowData: Record<string, unknown>
  rowIndex: number
  column: ColumnShape<Record<string, unknown>>
}

const SelectionCell = ({ rowData, rowIndex, column }: Props): ReactElement => {
  const { selectedRowKeys, rowKey, onChange } = column

  const handleChange = e => {
    onChange({ selected: e.target.checked, rowData, rowIndex })
  }

  const checked = selectedRowKeys.includes(rowData[rowKey])

  return <input type="checkbox" checked={checked} onChange={handleChange} />
}

export default SelectionCell
